export default __webpack_public_path__ + "static/media/UST.84c387f4.png";